import { render, staticRenderFns } from "./SubscriptionSummary.vue?vue&type=template&id=83adb56e&scoped=true&"
import script from "./SubscriptionSummary.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSummary.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionSummary.vue?vue&type=style&index=0&id=83adb56e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83adb56e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83adb56e')) {
      api.createRecord('83adb56e', component.options)
    } else {
      api.reload('83adb56e', component.options)
    }
    module.hot.accept("./SubscriptionSummary.vue?vue&type=template&id=83adb56e&scoped=true&", function () {
      api.rerender('83adb56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubscriptionSummary.vue"
export default component.exports